<template>
  <span
    v-if="productBadge"
    class="
      product-card__badge
      text-desktop-10-desktop
      text-mobile-10-mobile
    "
    :class="[$blockClass(blockClass, 'product-badge')]"
    v-text="productBadge"
  />
</template>

<script>

/**
 * Vue: Product badge (product-badge)
 * -----------------------------------------------------------------------------
 * Badge shown on product card based on tag.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {Boolean|Object} product - Liquid product object.
 *
 */
export default {
  name: 'ProductBadge',

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },

  computed: {

    /**
     * Compute product badge from product tags
     * @returns {String}
     */
    productBadge() {
      const badgeTag = this.product?.tags?.find((tag) => {
        // Only display non-loyalty badges
        return tag.includes('badge:') && !tag.includes('loyalty')
      })

      return badgeTag?.replace('badge:', '')
    },
  },
}
</script>
